import { render } from "./EditRacer.vue?vue&type=template&id=6c507520&scoped=true"
import script from "./EditRacer.vue?vue&type=script&lang=js"
export * from "./EditRacer.vue?vue&type=script&lang=js"

import "./EditRacer.vue?vue&type=style&index=0&id=6c507520&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c507520"]])

export default __exports__